import React from 'react'
import { cn } from 'lib/utils'
import { Switch as ShadcnSwitch } from 'components/ui/switch'
import { Label } from 'components/ui/label'

export default function SwitchControl(props) {
	const { name, label, value, onChange, className } = props

	const convertToDefEventPara = (name, value) => ({
		target: { name, value },
	})

	return (
		<div className={cn('tw-form-control flex items-center gap-2', className)}>
			<ShadcnSwitch
				name={name}
				checked={!!value}
				onChange={e => onChange(convertToDefEventPara(name, e.target.checked))}
			/>
			{label && (
				<Label className="cursor-pointer">
					{label}
				</Label>
			)}
		</div>
	)
}
